import { ComponentType } from 'react';

import { ReactComponent as DealIcon } from 'assets/handshake-black.svg';
import { ReactComponent as LeadIcon } from 'assets/leads-icon-black.svg';
import { ReactComponent as TaskIcon } from 'assets/task-black.svg';

import { QuickActionButtonVariantType } from '../types';

import RoutePaths from 'routes/RoutePaths';
import { getNewPath } from 'routes/utils';

export const ICON_MAP: Record<QuickActionButtonVariantType, ComponentType> = {
  task: TaskIcon,
  deal: DealIcon,
  lead: LeadIcon,
};

export const ACTION_ROUTE: Record<QuickActionButtonVariantType, string> = {
  task: RoutePaths.Tasks,
  deal: getNewPath(RoutePaths.Deals),
  lead: RoutePaths.Leads,
};
